export const routes = [
    {
        context: 'identity',
        method: 'GET',
        path: '/invitations',
        operationId: 'Invitations_list',
        auth: 'tenant',
        action: 'invitation:list',
        tool: 'identity_Invitations_list',
        description: "Open and recent invitations into the caller's tenant.",
        pathParams: [],
        queryParams: ['cursor', 'limit', 'status'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'POST',
        path: '/invitations',
        operationId: 'Invitations_create',
        auth: 'tenant',
        action: 'invitation:create',
        tool: 'identity_Invitations_create',
        description: 'Invite someone into the tenant. Creates the user with a temporary password and emails them.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'identity',
        method: 'GET',
        path: '/invitations/{invitationId}',
        operationId: 'Invitations_get',
        auth: 'tenant',
        action: 'invitation:read',
        tool: 'identity_Invitations_get',
        description: 'One invitation.',
        pathParams: ['invitationId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'POST',
        path: '/invitations/{invitationId}/resend',
        operationId: 'Invitations_resend',
        auth: 'tenant',
        action: 'invitation:resend',
        tool: 'identity_Invitations_resend',
        description: 'Re-send the invitation email with a fresh temporary password.',
        pathParams: ['invitationId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'POST',
        path: '/invitations/{invitationId}/revoke',
        operationId: 'Invitations_revoke',
        auth: 'tenant',
        action: 'invitation:revoke',
        tool: 'identity_Invitations_revoke',
        description: 'Revoke a pending invitation.',
        pathParams: ['invitationId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'GET',
        path: '/me',
        operationId: 'Self_get',
        auth: 'tenant',
        action: 'me:read',
        tool: 'identity_Self_get',
        description: 'Who is calling, and under which membership.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'POST',
        path: '/me/consents',
        operationId: 'Self_consent',
        auth: 'tenant',
        action: 'me:consent',
        assistantExempt: "consent is the person's own act; a model never gives it for them",
        description: 'Record that the caller accepted these documents (a new version, after sign-up). 409 when a\nversion is not the current one: show the documents again. Answers `GET /me` afterwards.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'GET',
        path: '/me/memberships',
        operationId: 'Self_memberships',
        auth: 'tenant',
        action: 'me:read',
        tool: 'identity_Self_memberships',
        description: 'Every tenant the caller belongs to. Cross-tenant by nature; each row is scoped to its own tenant.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'GET',
        path: '/members',
        operationId: 'Members_list',
        auth: 'tenant',
        action: 'membership:list',
        tool: 'identity_Members_list',
        description: "Members of the caller's tenant.",
        pathParams: [],
        queryParams: ['cursor', 'limit'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'DELETE',
        path: '/members/{sub}',
        operationId: 'Members_remove',
        auth: 'tenant',
        action: 'membership:remove',
        tool: 'identity_Members_remove',
        description: 'Remove a member from the tenant. Their identity is untouched elsewhere.',
        pathParams: ['sub'],
        queryParams: [],
        hasBody: false,
        successStatus: 204,
    },
    {
        context: 'identity',
        method: 'GET',
        path: '/members/{sub}',
        operationId: 'Members_get',
        auth: 'tenant',
        action: 'membership:read',
        tool: 'identity_Members_get',
        description: "One member of the caller's tenant.",
        pathParams: ['sub'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'identity',
        method: 'PATCH',
        path: '/members/{sub}',
        operationId: 'Members_update',
        auth: 'tenant',
        action: 'membership:update',
        tool: 'identity_Members_update',
        description: "Change a member's roles, office, agent code or grants.",
        pathParams: ['sub'],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map